import React from 'react';

import { ProgressBar } from 'react-loader-spinner';

import type { ProgressBarSpinnerProperties } from './ProgressBarSpinner.types';

export const ProgressBarSpinner: React.FC<ProgressBarSpinnerProperties> = ({
  dataTest = 'simple_circle_spinner',
  size = '15',
  isLoading,
  barColor = 'primary',
  borderColor = 'secondary',
}) => {
  // Без фолбэка намеренно (AF-40). Переменные `--mui-palette-*` эмитит MUI
  // при `cssVariables: true`, и они есть всегда — замерено в браузере:
  // `--mui-palette-error-main` = `#C62828`, вычисленный цвет элемента с
  // фолбэком был токеном, а не фолбэком. Если переменной вдруг не окажется,
  // спиннер должен остаться без цвета и это должно быть видно, а не
  // подмениться значением, которое никто не выбирал.
  const mainColorString = `var(--mui-palette-${barColor}-main)`;
  const secondaryColorString = `var(--mui-palette-${borderColor}-main)`;
  return (
    <ProgressBar
      data-testid={dataTest}
      width={size}
      height={size}
      barColor={mainColorString}
      borderColor={secondaryColorString}
      ariaLabel='progress-bar-loading'
      visible={isLoading}
    />
  );
};
